import { formatDate } from '@angular/common';

import { formats } from '@environment';

export function formatDateTimeLong(value: string | Date, format: string = formats.dateTimeLongFormat): string {
  if (!value) {
    return null;
  }

  return formatDate(value, format, 'en-US', 'GMT');
}
